// Copyright (c) 2022 by Move Closer

import { ImageProps } from '../../../dsl/atoms/Image'

/**
 * Generate image placeholder.
 */
export const generateImagePlaceholder = (
  size: string,
  altText?: string
): ImageProps => {
  const DEFAULT_SIZE = 'small'
  const ALLOWED_SIZES = ['small', 'medium', 'large']

  let currentSize = size
  if (!ALLOWED_SIZES.includes(size)) {
    currentSize = DEFAULT_SIZE
  }

  const src: string = require(`../../../../assets/images/image-placeholder-${currentSize}.jpg`)
  const alt: string = altText ?? 'Image placeholder'

  return { src, alt }
}
